import React from "react";

import { Collapse, RotatingChevron } from "@newsela/angelou";

import {
  collapseButtonCss,
  collapseCss,
  expanderContentCss,
  headerCss,
} from "./FilterSection.styles";

interface FilterSectionProps {
  title: string;
  children: React.ReactNode;
  defaultCollapsed?: boolean;
}

export const FilterSection = ({
  title,
  children,
  defaultCollapsed = true,
}: FilterSectionProps) => {
  const { isHidden, onClick } = Collapse.useCollapse({
    isHidden: defaultCollapsed,
  });

  return (
    <Collapse
      isHidden={isHidden}
      onClick={onClick}
      __cssFor={{
        ...collapseCss,
        Button: collapseButtonCss,
        expander: {},
        expanderContent: expanderContentCss,
      }}
      initialIsHidden={false}
      renderCustomTrigger={(props, isHidden, Button) => (
        <Button
          ariaProps={{ "aria-expanded": isHidden ? "false" : "true" }}
          dataProps={{
            "data-qa-selector": `search-${title.toLowerCase().replace(" ", "-")}-section`,
          }}
          {...props}
          flavor={Button.flavors.incognito}
          __cssFor={{
            root: {
              width: "100%",
            },
          }}
        >
          <h2 css={headerCss}>
            {title}
            <RotatingChevron isDown={isHidden} />
          </h2>
        </Button>
      )}
    >
      {children}
    </Collapse>
  );
};
